/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectTaskBudgetCostCommand } from '../../models/delete-project-task-budget-cost-command';
import { DeleteProjectTaskBudgetCostCommandResult } from '../../models/delete-project-task-budget-cost-command-result';

export interface ApiTaskBudgetCostDeleteTaskBudgetCostDelete$Plain$Params {
      body?: DeleteProjectTaskBudgetCostCommand
}

export function apiTaskBudgetCostDeleteTaskBudgetCostDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiTaskBudgetCostDeleteTaskBudgetCostDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectTaskBudgetCostCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskBudgetCostDeleteTaskBudgetCostDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectTaskBudgetCostCommandResult>;
    })
  );
}

apiTaskBudgetCostDeleteTaskBudgetCostDelete$Plain.PATH = '/api/TaskBudgetCost/DeleteTaskBudgetCost';
